
import {defineComponent, inject, onMounted, PropType} from "vue";
import NodeListTile from "@/components/NodeListTile.vue";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "NodeList",
  components: {NodeListTile},
  props: {
    parent: {
      type: Number
    }
  },
  setup(props) {
    const mapStore = useMapStore()
    const nodes = mapStore.getNodesByParent(props.parent);
    if (nodes.length == 1) {
      mapStore.addToNodePath(nodes[0]);
    }
    return {
      nodes,
      mapStore
    }
  }
})

